import {useEffect} from "react";
import {useLocation} from "react-router-dom";

/**
 * ScrollToTop is a React component that scrolls the window to the top whenever the URL changes.
 * It's designed to be used with React Router Dom v6.
 * @returns {null}
 */
export default function ScrollToTop() {
    const {pathname} = useLocation();

    useEffect(() => {
        // Scroll the document element to the top left corner of the window
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant", // Optional: skip the scrolling animation
        });
    }, [pathname]); // Re-run the effect whenever the URL changes

    // This component doesn't render anything, so it returns null
    return null;
}